import { TextareaHTMLAttributes, useEffect, useState } from "react";
import { FormTemplate } from "../../dtos/FormTemplate";
import "../MfEditorPage.scss";
type FormTemplateEditorProps = {
  template: FormTemplate;
  onChange: (template: FormTemplate) => void;
};

const FormTemplateEditor: React.FC<FormTemplateEditorProps> = ({
  template,
  onChange,
}) => {
  return (
    <div
      style={{
        display: "flex",
        flexDirection: "column",
        alignItems: "start",
        justifyContent: "center",
        height: "100%",
        width: "100%",
        maxHeight: "100%",
        backgroundColor: "rgba(0,0,0,0.2)",
        padding: "20px",
        margin: "20px",
        borderRadius: "10px",
      }}
    >
      <div className="editor-container1">
        <h1 className="text-normal text-medium primary-color">
          Nombre de la plantilla:
        </h1>
        <input
          type="text"
          value={template.name}
          onChange={(e) => {
            onChange({ ...template, name: e.target.value });
          }}
          className="text-normal text-small primary-color-80 input1"
        />
        <h1 className="text-normal text-medium primary-color">
          Frontend personalizado:
        </h1>
        <input
          type="text"
          value={template.customFront}
          onChange={(e) => {
            onChange({ ...template, customFront: e.target.value });
          }}
          className="text-normal text-small primary-color-80 input1"
        />
      </div>
      <div className="editor-container1">
        <h1 className="text-normal text-medium primary-color">Constantes</h1>
        <GetConstantsView
          constants={template.constants}
          onChange={(constants) => {
            onChange({ ...template, constants });
          }}
        />
      </div>
    </div>
  );
};
export default FormTemplateEditor;

// const getConstantsView
type ConstantsViewProps = {
  constants: { [key: string]: string };
  onChange: (constants: { [key: string]: string }) => void;
};
const GetConstantsView: React.FC<ConstantsViewProps> = ({
  constants,
  onChange,
}) => {
  type LocalConstant = {
    id: string;
    key: string;
    value: string;
  };
  const [localEdited, setLocalEdited] = useState(false);
  const [localConstants, setLocalConstants] = useState<LocalConstant[]>([]);
  //Load Constants to local state
  useEffect(() => {
    let newLC = Object.keys(constants).map((key) => {
      return { id: Math.random().toString(), key, value: constants[key] };
    });
    setLocalConstants(newLC);
  }, [constants]);
  function deleteConstant(key: string) {
    setLocalEdited(true);
    let newLC = localConstants.filter((lc) => lc.key !== key);
    setLocalConstants(newLC);
  }

  function changeKey(oldId: string, newKey: string) {
    setLocalEdited(true);
    let newLC = localConstants.map((lc) => {
      if (lc.id === oldId) {
        return { ...lc, key: newKey };
      }
      return lc;
    });
    setLocalConstants(newLC);
  }

  function auto_grow(element: HTMLTextAreaElement) {
    element.style.height = "5px";
    element.style.height = element.scrollHeight + 10 + "px";
  }

  function changeValue(key: string, value: string) {
    setLocalEdited(true);
    let newLC = localConstants.map((lc) => {
      if (lc.key === key) {
        return { ...lc, value };
      }
      return lc;
    });
    setLocalConstants(newLC);
  }
  return (
    <div
      style={{
        padding: "10px",
        background: "rgba(0,0,0,0.2)",
        borderRadius: "10px",
        maxHeight: "70vh",
        overflow: "scroll",
      }}
    >
      <table>
        <thead
          className="text-normal text-small primary-color"
          style={{
            height: "30px",
            textAlign: "center",
          }}
        >
          <tr style={{ height: "15px" }}>
            <th style={{ width: "300px" }}>Llave (id)</th>
            <th style={{ width: "600px" }}>Valor</th>
            <th></th>
          </tr>
        </thead>
        <tbody
          className={`text-normal text-small primary-color-50`}
          style={{
            textAlign: "center",
            margin: "5px 0 5px 0",
          }}
        >
          {localConstants.map((lc) => {
            return (
              <tr
                key={lc.id}
                className=""
                style={{
                  padding: "2px",
                  marginBottom: "5px",
                  //   flexDirection: "row",
                  //   display: "flex",
                  //   alignItems: "center",
                }}
              >
                <td style={{ border: "none", marginBottom: "5px" }}>
                  <input
                    style={{ marginBottom: "5px" }}
                    type="text"
                    value={lc.key}
                    onChange={(e) => {
                      changeKey(lc.id, e.target.value);
                    }}
                    className="text-normal text-small primary-color-80 input1"
                  />
                </td>
                <td style={{ border: "none" }}>
                  <textarea
                    style={{
                      width: "600px",
                      textAlign: "justify",
                      padding: "5px",
                      marginBottom: "10px",
                    }}
                    value={lc.value}
                    onClick={(e) => {
                      auto_grow(e.target as HTMLTextAreaElement);
                    }}
                    onLoad={(e) => {
                      auto_grow(e.target as HTMLTextAreaElement);
                    }}
                    onChange={(e) => {
                      changeValue(lc.key, e.target.value);
                      auto_grow(e.target as HTMLTextAreaElement);
                    }}
                    className="text-normal text-small primary-color-80 input1"
                  />
                </td>
                <td style={{ border: "none" }}>
                  <button
                    className="boton1"
                    onClick={() => {
                      deleteConstant(lc.key);
                    }}
                  >
                    Eliminar
                  </button>
                </td>
              </tr>
            );
          })}
        </tbody>
      </table>
      <button
        className="boton1"
        style={{ marginTop: "20px" }}
        onClick={() => {
          setLocalEdited(true);
          setLocalConstants([
            ...localConstants,
            {
              id: Math.random().toString(),
              key: "",
              value: "",
            },
          ]);
        }}
      >
        Agregar constante
      </button>
      {localEdited && (
        <button
          className="boton1"
          style={{ marginTop: "20px" }}
          onClick={() => {
            setLocalEdited(false);
            let newConstants: { [key: string]: string } = {};
            localConstants.forEach((lc) => {
              newConstants[lc.key] = lc.value;
            });
            onChange(newConstants);
          }}
        >
          Guardar Cambios
        </button>
      )}
    </div>
  );
};
